import { Link, useNavigate } from 'react-router-dom'
import './Login.css'
import React from 'react'
import { useState, useEffect } from 'react'
import { writeUserData } from './Firebase';
import { auth } from "./Firebase";
import { getAuth } from "firebase/auth";
import { getDatabase, ref, child, get } from "firebase/database";


export default function OrderForm(){
  const auth1 = getAuth();
  const user = auth1.currentUser;
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
  const dbRef = ref(getDatabase());
    get(child(dbRef, `users/${user.uid}`)).then((snapshot) => {
      if (snapshot.exists()) {
        navigate('/user')
      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      console.error(error);
    });
    }, []);
  return (
    <div className='my-5 body-login'>
      <hr style={{color: "black", backgroundColor: "black",visibility: "hidden"}}></hr>
      <hr style={{color: "black", backgroundColor: "black",visibility: "hidden"}}></hr>
      <div className='RegLog-login my-5'>

      <div className='form-login my-5'>
        <h3 style={{color: 'white'}}>Please enter your details</h3>
            <label style={{color: "white"}}>Please Enter Your Phone Number:</label><br></br>
            <input placeholder='+92-300-1234567'
             value={phone} autoComplete='on' pattern="[0-9]{3}-[0-9]{3}-[0-9]{7}"
            type='tel' minLength='11' maxLength="15" onChange={(e)=>{setPhone(e.target.value)}} required={true}></input><br></br>
            <label style={{color: "white"}}>Please enter your Address</label><br></br>
            <input placeholder='Place Your address Here' autoComplete='on'
            //  style={{zIndex: '-1'}}
            value={address} onChange={(e)=>{setAddress(e.target.value)}} required={true}>
            </input>
            <button className='btn btn-login my-4' style={{margin: "auto", width: "100%"}}
            onClick={()=> submitted(user.uid, user.displayName, phone, address)}> Submit </button>
              </div>
        </div>
    </div>
  )
  function submitted(id, name, phone, add){
    writeUserData(id, name, phone, add);

    console.log(id + name + phone + add)
  }
}
